import { createFileRoute } from "@tanstack/react-router";

import { BaseEditCreateModal } from "@/components/_Modals/BaseEditCreateModal";
import { TruckForm } from "@/features/dashboard/caminhoes/components/TruckForm";

export const Route = createFileRoute("/_private/dashboard/_trucks/caminhoes/carregamentos/cadastrar/modal")({
  component: () => (
    <BaseEditCreateModal title="Criar novo Carregamento" from="/dashboard/caminhoes/carregamentos/cadastrar">
      <TruckForm />
    </BaseEditCreateModal>
  )
});
